import React from 'react';

const Services = () => {
  return (
    <div id="services">
      <div className="container">
        <h1 className="subtitle">My Services</h1>
        <div className="services-list">
          <div>
            <i className="fa-solid fa-code"></i>
            <h2>Web Development</h2>
            <p>I will create user friendly web applications that will be device adjusting</p>
            <a href="#">Learn more</a>
          </div>
          <div>
            <i className="fa-solid fa-crop"></i>
            <h2>SEO</h2>
            <p>I will analyze your site and do onpage and offpage SEO</p>
            <a href="#">Learn more</a>
          </div>
          <div>
            <i className="fa-solid fa-blog"></i>
            <h2>Article/Blog Writing</h2>
            <p>I will write engaging and attention grabbing content for your blog or article</p>
            <a href="#">Learn more</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
